import React, { useState } from 'react'
import MainLayout from '../../layouts/Main'

// import { useGetUserCampuses } from '../../../hooks/campuses';
import { useExportInterviewReportForSchool, useGetInterviewReportForSchool } from '../../../hooks/analytics';

import BarChart from '../../sub_components/charts/BarChart';
import FilterTable from '../../sub_components/tables/FilterTable';
import ReportDatePicker from '../../sub_components/ReportDatePicker';
import ReportTablet from '../../sub_components/ReportTablet';

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/tables';
import { InterviewMode, InterviewQuestionType } from '../../../interfaces';

import { getDateString } from '../../../helpers/utility';

const InterviewReport = () => {
    // let filterTableDataColumns__Campuses: IColumnProps[] = [
    //     { name: "ID", identifier: "id" },
    //     { name: "Campus", identifier: "name" },
    // ];
    let filterTableDataColumns__QuestionType: IColumnProps[] = [
        { name: "Interview Type", identifier: "name" },
    ];
    let filterTableDataColumns__Mode: IColumnProps[] = [
        { name: "Interview Mode", identifier: "name" },
    ];
    let filterTableDataColumns__InterviewReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Email", identifier: "email" },
        { name: "InterviewType", identifier: "question_type" },
        { name: "Interview Mode", identifier: "mode" },
        { name: "Completed At", identifier: "completed_at" },
    ];

    // let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__InterviewReport: IFilterableDataProps[] = [];
    let filterTableData__QuestionType: IFilterableDataProps[] = [];
    let filterTableData__Mode: IFilterableDataProps[] = [];

    const [campusFilters, setCampusFilters] = useState<number[]>([]); // eslint-disable-line
    const [questionTypeFilters, setQuestionTypeFilters] = useState<number[]>([]);
    const [modeFilters, setModeFilters] = useState<number[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const interviewQuestionTypeOptions = Object.values(InterviewQuestionType).map((type, index) => ({
        id: index,
        name: type,
    }));
    const interviewModeOptions = Object.values(InterviewMode).map((mode, index) => ({
        id: index,
        name: mode,
    }));

    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));
    questionTypeFilters.forEach((id) => filterQuery.append("question_types", interviewQuestionTypeOptions[id].name));
    modeFilters.forEach((id) => filterQuery.append("modes", interviewModeOptions[id].name));

    // const { data: campuses } = useGetUserCampuses();
    const { data: interviewReport } = useGetInterviewReportForSchool(filterQuery.toString());
    
    const { mutate: exportCsv } = useExportInterviewReportForSchool();

    // if (campuses) {
    //     filterTableData__Campuses = campuses.map((campus) => ({
    //         id: campus.id,
    //         name: campus.name,
    //     }));
    // }

    if (interviewReport) {
        filterTableData__InterviewReport = interviewReport.table_data.map((interview) => ({
            id: interview.id,
            full_name: interview.full_name,
            email: interview.email,
            question_type: interview.question_type,
            mode: interview.mode,
            completed_at: getDateString(interview.completed_at),
        }));
    }

    if (interviewQuestionTypeOptions) {
        filterTableData__QuestionType = interviewQuestionTypeOptions.map((type) => ({
            id: type.id,
            name: type.name,
        }));
    }

    if (interviewModeOptions) {
        filterTableData__Mode = interviewModeOptions.map((mode) => ({
            id: mode.id,
            name: mode.name,
        }));
    }

    const onExportCsv = () => {
        exportCsv({ payload: { filterQuery: filterQuery.toString() } });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>Interview Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of interviews completed by students.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row'>
                        {/* {campuses?.length
                            ? <FilterTable
                                columns={filterTableDataColumns__Campuses}
                                data={filterTableData__Campuses}
                                filters={campusFilters}
                                setFilters={setCampusFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No campuses found
                            </div>
                        } */}
                        <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__vertical'>
                            <ReportDatePicker
                                required={true}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                            <div className='immersion__careers_report__chart__row'>
                                <ReportTablet
                                    title={interviewReport?.total_interviews_completed?.toString() ?? "0"}
                                    description='Total Interviews Completed'
                                    color={'green'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__QuestionType}
                            data={filterTableData__QuestionType}
                            filters={questionTypeFilters}
                            setFilters={setQuestionTypeFilters}
                            enableFilters={true}
                        />
                        {interviewReport?.question_type_chart_data.length ? (
                            <BarChart
                                data={interviewReport?.question_type_chart_data ?? []}
                                width={600}
                                height={318}
                                xLabel="Question Type"
                                yLabel="No. of Interviews"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No interviews completed
                            </div>
                        )}
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__Mode}
                            data={filterTableData__Mode}
                            filters={modeFilters}
                            setFilters={setModeFilters}
                            enableFilters={true}
                        />
                        {interviewReport?.mode_chart_data.length ? (
                            <BarChart
                                data={interviewReport?.mode_chart_data ?? []}
                                width={600}
                                height={318}
                                xLabel="Mode"
                                yLabel="No. of Interviews"
                                xInterval={0}
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No interviews completed
                            </div>
                        )}
                    </div>
                    <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__width_75'>
                        <FilterTable
                            columns={filterTableDataColumns__InterviewReport}
                            data={filterTableData__InterviewReport}
                            filters={[]}
                            setFilters={() => { }}
                            enableFilters={false}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default InterviewReport;